<template>
  <div
    class="search-container"
    :style="{ background: inputBgColor }"
    :class="{ round: shape === 'round' }"
  >
    <input
      type="text"
      class="search-input"
      :placeholder="placeholder"
      v-model="searchValue"
      @keyup.enter="handleSearch"
    />
    <button class="search-btn" type="button" @click="handleSearch">
      <svg
        v-if="!buttonText"
        class="search-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <span v-else>{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchBox",
  props: {
    // 输入框提示文字
    placeholder: {
      type: String,
      default: "请输入搜索内容",
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: "",
    },
    // 搜索框整体背景色
    inputBgColor: {
      type: String,
      default: "#ffffff",
    },
    shape: {
      type: String,
      default: "round",
    },
  },
  data() {
    return {
      searchValue: "",
    };
  },
  methods: {
    // 处理搜索逻辑
    handleSearch() {
      // 将搜索值通过事件传递给父组件
      this.$emit("search", this.searchValue);
    },
  },
};
</script>

<style scoped lang="less">
.search-container {
  display: flex;
  align-items: center;
  width: 240px;
  height: 30px;
  padding: 3px 4px 3px 12px;
  overflow: hidden;
  z-index: 99;
  box-sizing: border-box;
  box-shadow: inset 0px 4px 15px 0px rgba(255, 255, 255, 0.3);
}
.round {
  border-radius: 22px;
}

.search-input {
  flex: 1;
  min-width: 0;
  height: 24px;
  padding: 0 8px;
  border: none;
  outline: none;
  font-size: 12px;
  background-color: transparent;
}

.search-input::placeholder {
  color: #999;
}

.search-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #3b3b3b;
  font-size: 14px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.search-icon {
  display: block;
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.search-btn:hover {
  opacity: 0.9;
}
</style>
